import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsVelomobileNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.44 9.96l1.25-.7v-.01l1.3-.73a8.737 8.737 0 011.684-.72 2.449 2.449 0 002.455 2.3c.1 0-.49.033 9.1-.533a9.339 9.339 0 015.43 1.36l.1.06a1.217 1.217 0 01.57 1.02 1.188 1.188 0 01-.46.93 6.327 6.327 0 01-3.386 1.341 3.118 3.118 0 00-6.082.049h-9.83l-.63-3.66-1.25.71.74 4.29H3.4a3.172 3.172 0 006.2 0h2.8a3.124 3.124 0 006.11-.042A7.765 7.765 0 0022.71 14a2.506 2.506 0 00.96-1.99 2.554 2.554 0 00-1.21-2.17l-.1-.06a10.7 10.7 0 00-6.21-1.56l-4.38.28a5.177 5.177 0 00-4.43-2.48 10.284 10.284 0 00-5.02 1.32L.2 8.55l.24 1.41zm6.06 6.865a1.827 1.827 0 01-1.694-1.155h3.388A1.827 1.827 0 016.5 16.825zm8.95-.05a1.775 1.775 0 11.002-3.55 1.775 1.775 0 01-.002 3.55zM6.006 7.483c.441-.072.887-.11 1.334-.113a3.837 3.837 0 012.812 1.219l-2.965.162a1.13 1.13 0 01-.83-.3 1.114 1.114 0 01-.35-.814v-.154z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsVelomobileNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsVelomobileNormalSmall;
